module.exports = __webpack_public_path__ + "img/r4-ur3.5ed5cb22.jpg";